import { render, staticRenderFns } from "./ConsentSettings.vue?vue&type=template&id=acee957e&scoped=true&"
import script from "./ConsentSettings.vue?vue&type=script&lang=js&"
export * from "./ConsentSettings.vue?vue&type=script&lang=js&"
import style0 from "./ConsentSettings.vue?vue&type=style&index=0&id=acee957e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acee957e",
  null
  
)

export default component.exports